import {useState, useEffect} from 'react'

const useFetchPOST = (url, data) => {    
    const [error, setError] = useState(null);
    const [responseData, setResponseData] = useState(null);
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {                
        if (!data) return; // Only trigger the fetch if there's data to send
        
        const fetchData = async () => {            
            const AbortCtrl = new AbortController();        
            setLoading(true);
            try {
                const response = await fetch(url, {
                    signal: AbortCtrl.signal,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        },
                    body: JSON.stringify(data)
                    });
                
                if (response.ok)
                {
                    setResponseData(await response.json());
                    setError(null);
                    console.log(`posting data to [${url}] was succesfull.`);
                } else {
                    const errorText = await response.text();
                    setError(`ERROR: [${errorText}]`);
                    console.log(errorText);
                }
            } catch (error) {                
                if (error.name === "AbortError") {
                    setError("ERROR: fetching data was aborted...");
                    console.log("fetching data was aborted...");
                }
                else {                                        
                    console.log(error.message);
                    setError(`ERROR: [${error.message}]`);
                }      
            } finally {
                setLoading(false);
            }
                            
            return () => { AbortCtrl.abort()};
        };

        fetchData();                
    }, [url, data]);

    return {error, responseData, loading}
}


export default useFetchPOST;